<template>
  <div class="sky-hc-page-table">
    <div class="sky-hc-page-table__page" :class="!hasSearch ? 'sky-hc-page-table__page--end' : ''">
      <div>
        <el-input
          v-if="hasSearch"
          :placeholder="searchPlaceholder"
          v-model="keyword"
          class="sky-hc-page-table__search-input"
          @keyup.native.enter="handleSearch"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
        </el-input>
        <slot name="btns"></slot>
      </div>
      <el-pagination
        layout="total, sizes, prev, sp, next"
        :pageSizes="[20, 30, 50, 100]"
        :pageSize="limit"
        :total="total"
        :current-page.sync="currentPage"
        v-if="total > 0 || alwaysShowPage"
        :simple-sizes="true"
        @prev-click="handlePrevClick"
        @next-click="handleNextClick"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-table
      ref="paginationTable"
      :data="data"
      :default-sort="defaultSort"
      :showOverflowTooltip="true"
      :special="true"
      :height="height"
      tooltip-effect="dark"
      class="sky-hc-page-table__table el-table--selection"
      @selection-change="handleSelectionChange"
      @filter-change="handleFilterChange"
      @sort-change="handleSortChange"
    >
      <slot name="columns"></slot>
    </el-table>
  </div>
</template>
<script>
import { Table, Pagination, Input } from 'element-ui'
export default {
  name: 'PaginationTable',
  components: {
    [Table.name]: Table,
    [Pagination.name]: Pagination,
    [Input.name]: Input
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    total: {
      type: [Number, String],
      default() {
        return 0
      }
    },
    limit: {
      type: [Number, String],
      default() {
        return 20
      }
    },
    page: {
      type: [Number, String],
      default() {
        return 0
      }
    },
    hasSearch: {
      type: Boolean,
      default() {
        return false
      }
    },
    searchPlaceholder: {
      type: String,
      default() {
        return ''
      }
    },
    defaultSort: {
      type: Object,
      default() {
        return {}
      }
    },
    height: {
      type: [String, Number, Object],
      default() {
        return null
      }
    },
    alwaysShowPage: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit)
    }
  },
  watch: {
    page() {
      this.currentPage = this.page
    }
  },
  data() {
    return {
      keyword: '',
      currentPage: 0
    }
  },
  methods: {
    handlePrevClick() {
      this.$emit('prevClick')
    },
    handleNextClick() {
      this.$emit('nextClick')
    },
    handleSizeChange(size) {
      this.$emit('sizeChange', size)
    },
    handleSelectionChange(selection) {
      this.$emit('selectionChange', selection)
    },
    handleFilterChange(filters) {
      const tableStates = this.$refs.paginationTable.store.states
      const resFilters = []

      const filteredColumns = Object.keys(tableStates.filters)
      const filteredValues = Object.values(tableStates.filters)
      tableStates.columns.map(item => {
        let index = filteredColumns.indexOf(item.id)
        if (index > -1 && filteredValues[index].length > 0) {
          resFilters.push({
            name: item.property,
            valueArr: filteredValues[index]
          })
        }
      })
      this.$emit('filterChange', resFilters)
    },
    handleSearch() {
      this.$emit('search', this.keyword)
    },
    handleCurrentChange(num) {
      this.$emit('currentChange', num)
    },
    handleSortChange(param) {
      this.$emit('sortChange', param)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-page-table) {
  @include e(page) {
    display: flex;
    justify-content: space-between;
    @include m(end) {
      justify-content: flex-end;
    }
    margin-bottom: 20px;
  }
  @include e(search-input) {
    width: 186px !important;
    .el-icon-search {
      height: 32px;
      cursor: pointer;
    }
  }
  @include e(table) {
  }
}
</style>
